<template lang="pug">
el-tag(
  v-if="value"
  size="mini"
  :type="type"
).ml {{ value }}
</template>

<script>
import { _ } from '@yishitec/web';

export default {
  name: 'ProgressStateTag',
  props: {
    value: { type: String, default: null },
  },
  computed: {
    type() {
      return (
        _.get(
          {
            未开始: 'info',
            进行中: 'warning',
            已完成: 'success',
          },
          this.value,
        ) || 'info'
      );
    },
  },
};
</script>
